import {
  getSTS
} from '@/api/sts'
let OSS = require('ali-oss')
export default {
  data() {
    return {
      region: process.env.VUE_APP_OSS_REGION,
      bucket: process.env.VUE_APP_BUCKET_NAME
    }
  },
  mounted() {

  },
  methods: {
    hasHttp(url) {
      var str=new RegExp(/(http|https):\/\/([\w.]+\/?)\S*/);
      return str.test(url)
    },
    getOssObj() {
      return getSTS({
        steUserId: '9999999'
      }).then(result => {
        const client = new OSS({
          region: result.regionId,
          accessKeyId: result.assumeRoleResponse?.credentials?.accessKeyId,
          accessKeySecret: result.assumeRoleResponse?.credentials?.accessKeySecret,
          stsToken: result.assumeRoleResponse?.credentials?.securityToken,
          bucket: result.bucketName,
          cname: true,
          endpoint: result.endpoint,
          timeout: 3600
        })
        // const client = new OSS({
        //   region: this.region,
        //   accessKeyId: result.token.credentials?.AccessKeyId,
        //   accessKeySecret: result.token.credentials?.AccessKeySecret,
        //   stsToken: result.token.credentials?.SecurityToken,
        //   bucket: this.bucket
        // })
        return client
      })
    },
    ossPut({
      file,
      objectName
    }) {
      return new Promise((resolve, reject) => {
        this.getOssObj().then(res => {
          res.multipartUpload(objectName, file,{
            progress: async function () {
            }
          }).then(({
            res,
            url
          }) => {
            if (res && res.status == 200) {
              this.$message.success({
                message: '上传文件成功',
                type: 'success',
                showClose: true
              });
              resolve(res, url);
            }
          }).catch((err) => {
            this.$message.error({
              message: '上传文件失败',
              type: 'error',
              showClose: true
            });
            reject(err)
          });
        })
      })
    },
    ossGet({
      objectName
    }) {
      return new Promise((resolve, reject) => {
        this.getOssObj().then(res => {
          res.get(objectName).then(({
            res
          }) => {
            if (res && res.status == 200) {
              resolve(res);
            }
          }).catch((err) => {
            // console.log('阿里云OSS下载文件失败回调', err);
            reject(err)
          });
        })
      })
    },
    ossSignatureUrl({
      objectName,
      config = {}
    }) {
      return new Promise((resolve) => {
        this.getOssObj().then(async (res) => {
          let url = await res.signatureUrl(objectName, config)
          resolve(url)
        })
      })
    },
    async getOssImageUrl(images,
      config) {
      if (Array.isArray(images)) {
        return Promise.all(images.map(item => {
          return this.ossSignatureUrl({
            objectName: item.url,
            config
          });
        }))
      } else {
        let url = await this.ossSignatureUrl({
          objectName: images,
          config
        });
        return url
      }
    }

  }
}